"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./RouteTabs.css");
var Tabs_1 = require("../Tabs");
var RouteTabs = /** @class */ (function (_super) {
    __extends(RouteTabs, _super);
    function RouteTabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RouteTabs.prototype.render = function () {
        return (React.createElement(Tabs_1.default, { "data-test-id": this.props.testId }, this.props.children));
    };
    return RouteTabs;
}(React.Component));
exports.default = RouteTabs;
//# sourceMappingURL=RouteTabs.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/RouteTabs/RouteTabs.js
// module id = 1265
// module chunks = 8